import { Card, Checkbox, Grid, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Tooltip, Typography } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import TaskIcon from '@mui/icons-material/Task';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';

const BoardImg = require('./../../assets/fileIcons/board.png');

import BoardInfoModal from "./BoardInfo.modal";
import FileAuditLogModal from "../file-audit-log/FileAuditLog.modal";
import { formatDate } from "src/methods/common.methods";
import constants from "../constants/common";

const flags = constants.flags;

class BoardCard extends React.Component {


	constructor(props) {
		super(props);
		this.state = {
			file: null,
			boardInfoModal: false
		}
	}

	boardInfo = async (file) => {
		if (!file) {
            return;
        }
        this.setState({ file: file, boardInfoModal: true });
	}

	viewBoard = async (file) => {
		console.log("viewBoard", file);
        if (!file || !file.external_path) {
            return;
        }
		window.open(file.external_path, '_blank');
	}

	// handleDelete = async (file) => {
	// 	if (!file) {
	// 		return;
	// 	}

	// 	// confirm swal
	// 	let c = await Swal.fire({
	// 		title: 'Are you sure?',
	// 		text: "You won't be able to revert this!",
	// 		icon: 'warning',
	// 		showCancelButton: true,
	// 		confirmButtonColor: '#d33',
	// 		cancelButtonColor: '#aaa',
	// 		confirmButtonText: 'Yes, delete it!'
	// 	});

	// 	if (c.isConfirmed) {
	// 		// Call the delete API or perform delete action
	// 		let response = await deleteFile(file._id);
	// 		// Handle response
	// 		if (response.error) {
	// 			Swal.fire({
	// 				title: 'Error!',
	// 				text: response.error,
	// 				icon: 'error',
	// 				confirmButtonText: 'Ok'
	// 			});
	// 			return;
	// 		}
	// 		this?.props?.onReload();
	// 		Swal.fire({
	// 			title: 'Deleted!',
	// 			text: 'Your board has been deleted.',
	// 			icon: 'success',
	// 			showConfirmButton: false,
	// 			timer: 2000,
	// 			timerProgressBar: true
	// 		});
	// 	}
	// }

	// handleDuplicate = async (file) => {
	// 	if (!file) {
	// 		return;
	// 	}

	// 	let response = await duplicateFile(file._id);
	// 	if (response.error) {
	// 		Swal.fire({
	// 			title: 'Error!',
	// 			text: response.error,
	// 			icon: 'error',
	// 			confirmButtonText: 'Ok'
	// 		});
	// 		return;
	// 	}
	// 	this?.props?.onReload();
	// 	Swal.fire({
	// 		title: 'Duplicated!',
	// 		text: 'Duplicate successful.',
	// 		icon: 'success',
	// 		showConfirmButton: false,
	// 		timer: 2000,
	// 		timerProgressBar: true
	// 	});
	// }

	menu = () => {
		return (
			<Menu
				id="simple-menu"
				anchorEl={this.state.anchorEl}
				open={Boolean(this.state.anchorEl)}
				onClose={() => this.setState({anchorEl: null})}
				anchorReference="anchorPosition"
				anchorPosition={{ top: this.state.clickY, left: this.state.clickX }}
			>
				{/* <MenuItem
					onClick={() => {
						this.handleDuplicate(this.props.file)
						this.setState({anchorEl: null})
					}}
				>
					<ListItemIcon>
						<ContentCopyIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText color="error">
						Duplicate
					</ListItemText>
				</MenuItem> */}
				<FileAuditLogModal
					file={this.props.file}
					onClose={() => this.setState({anchorEl: null})}
				/>
				<MenuItem onClick={() => {
					this.setState({anchorEl: null})
					this.props?.onSelect(this.props.file);
				}}>
					<ListItemIcon>
						<TaskIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText>
						{(this.props?.selected) ? 'Unselect' : 'Select'}
					</ListItemText>
				</MenuItem>
				{/* <Divider /> */}
				{/* <MenuItem color="error"
					onClick={() => {
						this.handleDelete(this.props.file)
						this.setState({anchorEl: null})
					}}
				>
					<ListItemIcon>
						<DeleteForeverIcon fontSize="small" color="error" />
					</ListItemIcon>
					<ListItemText color="error">
						Delete
					</ListItemText>
				</MenuItem> */}
			</Menu>
		)
	}
	
	cardHeaderTitle = (file) => {
		let show_selection = this.props?.showSelection;
		const nameWithoutExt = file.name.replace(/\.[^/.]+$/, "");
		return (
			<Tooltip title={file?.name}>
				{(show_selection) ? (
					<Checkbox
						checked={this.props?.selected}
						onChange={() => this.props?.onSelect(file)}
					/>
				) : null}
				{nameWithoutExt}
			</Tooltip>
		)
	}

	render() {

		let file = this.props.file;

		return (
			<>
			<Card variant="outlined"
				sx={{
					display: 'flex', flexDirection: 'column', padding: '8px', borderWidth: 3, borderColor:"divider"
				}}
				onContextMenu={(e) => {
					e.preventDefault();
					this.setState({
						anchorEl: e.currentTarget,
						clickX: e.clientX,
						clickY: e.clientY
					});
				}}
				onDoubleClick={() => this.viewBoard(file)}
			>
				{this.menu()}
				<Grid flex={1} flexDirection={'row'} justifyContent={'space-between'} display={'flex'} alignItems={"center"}>
					<img src={BoardImg} style={{height: '16px', width:"16px", marginRight:"8px",borderRadius:"6px", opacity:0.5}} />
					<Typography
						variant="body1"
						color="textPrimary" 
						noWrap
						sx={styles?.fileNameStyles}
					>
						{this.cardHeaderTitle(file)}
					</Typography>
					<Stack direction="row" spacing={1}>
					<Typography variant="caption" color="textSecondary" component="div" sx={{display: 'flex', alignItems: 'center'}}>
						{(file.flags && file.flags.length > 0) ? file.flags.map((flag, idx) => {

							let flag_data = flags.find(f => f.value == flag);
							if (flag_data?.icon) {
								return (
									flag_data.icon
								)
							}

							return null;
						}) : null}
					</Typography>
						{(file?.is_shared_outside_company) ? (
							<Tooltip title="Shared outside company">
								<PeopleOutlinedIcon fontSize="small" style={{ color: 'lightgray' }} />
							</Tooltip>
						) : null}
					</Stack>
				</Grid>
				<Grid sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end'}}>
					<Typography variant="caption" color="text.disabled" component="div" style={{ fontSize: 13 }}>
						{formatDate(file?.updated_at)}
					</Typography>

					<Stack direction="row" spacing={1}>
						<IconButton
							onClick={(e) => {
							e.preventDefault();
							this.setState({
								anchorEl: e.currentTarget,
								clickX: e.clientX,
								clickY: e.clientY,
							});
							}}
							sx={{ p: 0 }}
						>
							<MoreHorizOutlinedIcon />
						</IconButton>
					</Stack>
				</Grid>
				<Grid sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end'}}>
					{(!file?.is_owner) ? (
						<Stack direction="row" alignItems="center" style={{ opacity: 0.3 }}>
							<ShieldOutlinedIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: '2px', opacity: 0.3 }} />
							<Typography variant="body2" color="textSecondary" component="div" style={{ fontSize: 13 }}>
								{file?.owner?.name ? (file?.owner?.name + ' (' + file?.owner?.username + ')') : file?.owner?.username}
							</Typography>
						</Stack>
					) : (
						<Stack direction="row" alignItems="center" style={{ opacity: 0.3 }}>
							<ShieldOutlinedIcon fontSize="small" style={{ verticalAlign: 'middle', marginRight: '2px', opacity: 0.3 }} />
							<Typography variant="body2" color="textSecondary" component="div" style={{ fontSize: 13 }}>
								{'You'}
							</Typography>
						</Stack>
					)}
					<IconButton
						onClick={() => this.boardInfo(file)}
						sx={{ p: 0 }}
					>
						<KeyboardArrowDownIcon />
					</IconButton>
				</Grid>
			</Card>
			{(this.state.boardInfoModal) ? (
				<BoardInfoModal
                    hideAddButton={true}
                    file={file}
                    open={this.state.boardInfoModal}
                    onClose={() => this.setState({boardInfoModal: false})}
					onReload={this?.props?.onReload}
				/>
			) : null}
			</>
		)
	}
}

// Wrap and export
export default function (props) {
    const navigate = useNavigate();
    const params = useParams();

    return <BoardCard {...props} navigate={navigate} params={params} />;
}

const styles={
	fileNameStyles:{
		flex: 1,
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
}